var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('NavBar',{staticClass:"navbar"},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v("签到优惠券活动规则")])]),_c('div',{staticClass:"main"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.rule)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }